import { memo, useCallback, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { BzButton, BzToolTip } from "../../components";
import { useLeftClick } from "../../hooks";
import { Col, Container, Popover, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FACILITY_NUM, GLOBAL_FUNCTION_TYPES, MULTILEG_DATA_OPTION_INDEX, OPTION_CHAIN, OPTION_CHAIN_GRID_INDEX } from "../../utils/global_variables";
import { clearOptionChain, toggleOptionChainCheckBox, updateLegDataForOptionChain } from "../../redux/actions/optionChain";
import { convertScripResponseWatchlistGrid, getApiExchangeNameFromMktSegId, globalFunctionsEventDispatcher, isUserIsAGuest, setOrderEntryScripPrice } from "../../utils/global_functions";
import { _getScripsInfo } from "../../controllers";
import { getScripOrderInfo } from "../../redux/actions/orders";
import { handleModal } from "../../redux/actions/modals";
import { setArrScripToBeAdded } from "../../redux/actions/globalSearch";

const TogglerAndCheckBox = ({ arrRowData, ...props }) => {
    const dispatch = useDispatch();
    const arrLegDataForOptionChain = useSelector(state => state?.optionChain?.arrLegDataForOptionChain);
    const isToggle = useSelector(state => state?.optionChain?.isToggle);
    const objCFT = useSelector(state => state?.auth?.objCFT);

    const [showPopover, setShowPopover] = useState(false);

    const resetAllConditionsOnModalOpen = useCallback(() => {
        setShowPopover(false);
        dispatch(updateLegDataForOptionChain());
        dispatch(clearOptionChain());
    }, [dispatch]);

    /*
    Below function addes selected scrip to wathclist
    */
    const addScripModal = useCallback(async () => {
        const marketID = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[0] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[0];
        const token = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[1] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[1];
        const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(marketID), token: token }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        dispatch(setArrScripToBeAdded(scripData));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }]));
        convertScripResponseWatchlistGrid();
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'OPTION_CHAIN': false }]));
        resetAllConditionsOnModalOpen();
    }, [dispatch, arrRowData, resetAllConditionsOnModalOpen, props?.colDef?.type]);

    /*
        Below function is used for Buy or sell of selected scrip 
    */
    const handleOrderEntryModal = useCallback(async (nIsBuyOrSell) => {
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 20-03-2024 - BT-1207722 - Breeze -Guest User Privileges
            const marketID = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[0] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[0];
            const token = props?.colDef?.type === OPTION_CHAIN.CALL ? arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[1] : arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[1];
            resetAllConditionsOnModalOpen();
            const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(marketID), token: token }]);
            const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
            const scripData = convertScripResponseWatchlistGrid(scripDataObj);
            dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: marketID, scripData: scripData[0] }));
            setOrderEntryScripPrice(nIsBuyOrSell, scripData[0]);
            await dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }, { 'OPTION_CHAIN': false }, { 'ORDER_ENTRY_MODAL': true }]));
            globalFunctionsEventDispatcher([GLOBAL_FUNCTION_TYPES.CLOSING_SIDETRAY]);
        } else { }
    }, [arrRowData, resetAllConditionsOnModalOpen, props?.colDef?.type, dispatch]);

    /*
        Below function addes the legs that are slected while doing multileg order in option chain 
    */
    const getFullType = (type) => {
        switch (type) {
            case 'CE':
                return 'CALL';
            case 'PE':
                return 'PUT';
            default:
                return '';
        }
    };

    const addOrRemoveLegFromToaster = useCallback((type, scripType, data, indexToRemove) => {
        switch (type) {
            case 'add':
                let arrOptionChainIndexValues = Object.values(MULTILEG_DATA_OPTION_INDEX).sort((a, b) => a - b);
                let arrOptionChainIndex = new Array(arrOptionChainIndexValues[arrOptionChainIndexValues.length - 1] + 1).fill('');
                let newDAta = arrLegDataForOptionChain;
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LEG_NUMBER] = arrLegDataForOptionChain?.length + 1;
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SEGMENT_ID] = Number(data[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[0]);
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.TOKEN] = scripType === 'CE' ? Number(data[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN]?.split('_')[1]) : Number(data[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE]?.split('_')[1]);
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SCRIP_TYPE] = scripType;
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.NEXPIRY_DATE] = data[OPTION_CHAIN_GRID_INDEX.CALL_NEXPIRY_DATE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.STRIKE_PRICE] = data[OPTION_CHAIN_GRID_INDEX.STRIKE_PRICE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LTP] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.LTP_CALL] : data[OPTION_CHAIN_GRID_INDEX.LTP_PUT];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LEG_PRICE] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.LTP_CALL] : data[OPTION_CHAIN_GRID_INDEX.LTP_PUT];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.LTP_PERCENT] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_PERCENT_CHANGE_LTP] : data[OPTION_CHAIN_GRID_INDEX.PUT_PERCENT_CHANGE_LTP];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.CHANGE_IN_LTP] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_CHANGE_IN_LTP] : data[OPTION_CHAIN_GRID_INDEX.PUT_CHANGE_IN_LTP];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.BUY_PRICE] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_BUY_PRICE] : data[OPTION_CHAIN_GRID_INDEX.PUT_BUY_PRICE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SELL_PRICE] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.CALL_SELL_PRICE] : data[OPTION_CHAIN_GRID_INDEX.PUT_SELL_PRICE];
                arrOptionChainIndex[MULTILEG_DATA_OPTION_INDEX.SELECTED_EXPIRY] = scripType === 'CE' ? data[OPTION_CHAIN_GRID_INDEX.LTP_CALL] : data[OPTION_CHAIN_GRID_INDEX.LTP_PUT];
                newDAta.push(arrOptionChainIndex);
                dispatch(updateLegDataForOptionChain([...newDAta]));
                break;
            case 'remove':
                let updated = [...arrLegDataForOptionChain];
                updated.splice(indexToRemove, 1);
                updated = updated.map((item, idx) => {
                    const newItem = [...item];
                    newItem[0] = idx + 1;
                    return newItem;
                });
                dispatch(updateLegDataForOptionChain([...updated]));
                break;
            default:
                break;
        }
    }, [arrLegDataForOptionChain]);
    const handleCheckBoxClick = useCallback((event) => {
        event?.preventDefault();
        event?.stopPropagation();
        if (props?.colDef?.type === OPTION_CHAIN?.CALL) {
            // if scrip not present add if present remove 
            let nIndex = arrLegDataForOptionChain?.findIndex(item => {
                return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType(item[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]) === arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN];
            });
            if (nIndex === -1) {
                let data = arrRowData;
                data[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = true;
                addOrRemoveLegFromToaster('add', 'CE', data);
                // update ref so it give spl background for sleeclted leg
                props?.node?.updateData(data);

            } else if (nIndex > -1) {
                let dataCopy = arrRowData;
                dataCopy[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = false;
                props?.node?.updateData(dataCopy);
                // update ref so it remove spl background for sleeclted leg
                addOrRemoveLegFromToaster('remove', 'CE', dataCopy, nIndex);
            } else {
                // ussh silent do not do anything here 
            }
        } else if (props?.colDef?.type === OPTION_CHAIN?.PUT) {
            // if present delete if not add
            let aIndex = arrLegDataForOptionChain?.findIndex(item => {
                return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType(item[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]) === arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE];
            });

            if (aIndex === -1) {
                let data1 = arrRowData;
                data1[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = true;
                props?.node?.updateData(data1);
                addOrRemoveLegFromToaster('add', 'PE', data1);
                // update ref so it give spl background for sleeclted leg

            } else if (aIndex > -1) {
                let data1 = arrRowData;
                data1[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = false;
                props?.node?.updateData(data1);
                addOrRemoveLegFromToaster('remove', 'PE', data1, aIndex);
            } else {
                // ussh silent do not do anything here
            }
        } else {
            // ntg to do here
        }
    }, [dispatch, arrLegDataForOptionChain, props.colDef.type, props?.node, arrRowData]);

    /*
    Below function toggles option chain into multileg order 
    */
    const toggleMultilegCheckBox = useCallback(() => {
        dispatch(toggleOptionChainCheckBox(true));
        setShowPopover(false);
    }, [dispatch]);


    const BzPopover = (
        <Popover className='optiochain-popover'>
            {
                <>
                    <Popover.Header className='d-flex flex-column'>
                        <Container fluid className='p-0'>
                            <Row className='g-0 py-2 popover-menu'>
                                <Col className='d-flex justify-content-start align-items-center'>
                                    <BzButton className='btn btn-positive btn-sm text-uppercase me-1'
                                        onClick={handleOrderEntryModal.bind(this, 0)}
                                    >Buy</BzButton>
                                    <BzButton className='btn btn-negative btn-sm text-uppercase ms-1'
                                        onClick={handleOrderEntryModal.bind(this, 1)}
                                    >Sell</BzButton>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center ms-2'
                                            onClick={addScripModal}
                                        >
                                            <div class="icon-20 icon-add-circle icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                </Col>
                            </Row>
                            {
                                objCFT.MULTILEG === FACILITY_NUM.ON ?
                                    <Popover.Body className='d-flex flex-column'>
                                        <div className='bdr-top'>
                                            <Row className={`g-0 py-2 popover-menu`}>
                                                <Col className='d-flex align-items-center' onClick={toggleMultilegCheckBox}>
                                                    <input type='checkbox' id='create_multileg_order' className='form-check-input' />
                                                    <label htmlFor='create_multileg_order' className='font-regular font-size3 color-text ms-2 p-t-1'>Create Multileg Order</label>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Popover.Body> : null
                            }
                        </Container>
                    </Popover.Header>
                </>
            }
        </Popover>
    );

    /*
            Below function is used only when checkox is toggled an returns tru are false
            if the checkbox need to be checked by default
    */
    const isChecked = useCallback(() => { // used useCallBack insted useMemo because in case of no multileg we dont want this to run so avoided useMemo
        switch (props?.colDef?.type) {
            case OPTION_CHAIN.CALL:
                let nIndex = arrLegDataForOptionChain?.findIndex(item => {
                    return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType(item[MULTILEG_DATA_OPTION_INDEX?.SCRIP_TYPE]) === arrRowData[OPTION_CHAIN_GRID_INDEX.CALL_SEGMENT_ID_TOKEN];
                });
                if (nIndex > -1) {
                    let data = [...arrRowData];
                    if (!data[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR]) {
                        data[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = true;
                        props?.node?.updateData(data);
                    }
                    return true;

                } else {
                    let data1 = [...arrRowData];
                    if (data1[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR]) {
                        data1[OPTION_CHAIN_GRID_INDEX.CALL_MULTILEG_COLOR] = false;
                        props?.node?.updateData(data1);
                    }
                    return false;
                }
            case OPTION_CHAIN.PUT:
                let aIndex = arrLegDataForOptionChain?.findIndex(item => {
                    return item[MULTILEG_DATA_OPTION_INDEX?.SEGMENT_ID] + "_" + item[MULTILEG_DATA_OPTION_INDEX?.TOKEN] + '_' + getFullType("PE") === arrRowData[OPTION_CHAIN_GRID_INDEX.PUT_SEGMENT_ID_TOKE];
                });
                if (aIndex > -1) {
                    let data2 = [...arrRowData];
                    if (!data2[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR]) {
                        data2[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = true;
                        props?.node?.updateData(data2);
                    }
                    return true;

                } else {
                    let data3 = [...arrRowData];
                    if (data3[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR]) {
                        data3[OPTION_CHAIN_GRID_INDEX.PUT_MULTILEG_COLOR] = false;
                        props?.node?.updateData(data3);
                    }
                    return false;
                }
            default:
                return false;
        }

    }, [arrLegDataForOptionChain, props?.colDef?.type, arrRowData, props?.api, dispatch]);


    const leftClick = useCallback((e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    }, []);
    const [targetElement] = useLeftClick(leftClick);
    const onContextMenu = (e) => {
        if (e?.ctrlKey) {
            return;
        }
        setShowPopover(true);
    };

    return (<>
        {!isToggle ? <div ref={targetElement} onClick={onContextMenu}>
            <BsThreeDotsVertical />
        </div> : <input type="checkbox" disabled={arrLegDataForOptionChain?.length >= 3 ? true : false} checked={isChecked()} onChange={(e) => handleCheckBoxClick(e)} />}
    </>);
};

export default memo(TogglerAndCheckBox);